
export const VPNSection = () => {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'Military Encryption',
      description: 'Advanced AES-256 encryption ensures your data remains completely secure and private from any unauthorized access.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Network',
      description: 'Connect through our worldwide server network for optimal performance and unrestricted access to global content.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast',
      description: 'Experience blazing-fast connection speeds without compromising security or privacy protection.'
    }
  ];

  return (
    <section id="vpn" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center text-cyan-600 text-sm font-medium mb-4">
            <span className="w-2 h-2 bg-cyan-600 rounded-full mr-2"></span>
            Our Technology
          </div>
          <h3 className="text-4xl md:text-5xl font-serif text-navy-900 mb-6">
            Why Choose DUVANKA VPN
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div 
              key={index}
              className={`p-8 rounded-2xl transition-all duration-300 hover:scale-105 cursor-pointer ${
                index === 1 
                  ? 'bg-white shadow-xl hover:shadow-2xl' 
                  : 'bg-navy-900 text-white border-b-4 border-cyan-400'
              }`}
            >
              <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 ${
                index === 1 
                  ? 'bg-gradient-to-r from-cyan-400 to-purple-500' 
                  : 'bg-cyan-400'
              }`}>
                <i className={`${feature.icon} text-2xl ${index === 1 ? 'text-white' : 'text-navy-900'}`}></i>
              </div>
              
              <h4 className={`text-xl font-bold mb-4 ${
                index === 1 ? 'text-navy-900' : 'text-white'
              }`}>
                {feature.title}
              </h4>
              
              <p className={`leading-relaxed ${
                index === 1 ? 'text-gray-600' : 'text-gray-300'
              }`}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
